import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ClickableIconLabel from '../../../../../ClickableIconLabel/ClickableIconLabel';
import CreateEditITApplicationModalWrapper from '../../../../../EntityCrud/CreateEditITApplicationModalWrapper';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

export default function NewItApplicationToolbarButton({label, className, disabled, bodyId, onSaveComplete}) {
	const [showModal, setShowModal] = useState(false);

	return (
		<StyledNewItApplicationToolbarButton className={`NewItApplicationToolbarButton ${className}`}>
			<ClickableIconLabel
				disabled={disabled}
				text={label}
				iconName={IconoirPlusCircle}
				onClick={() => setShowModal(!showModal)}
			/>
			{!disabled && (
				<CreateEditITApplicationModalWrapper
					isManageEntities
					isCreate
					showModal={showModal}
					setShowModal={setShowModal}
					bodyId={bodyId}
					onSaveComplete={onSaveComplete}
				/>
			)}
		</StyledNewItApplicationToolbarButton>
	);
}

NewItApplicationToolbarButton.propTypes = {
	label: PropTypes.string.isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool
};

NewItApplicationToolbarButton.defaultProps = {
	className: 'body-special-toolbar-button',
	disabled: false
};

const StyledNewItApplicationToolbarButton = styled.section`
	display: flex;
	align-items: flex-end;
	margin-left: auto;
`;
